import React from 'react';
import { useSelector } from 'react-redux';
import { bindHandler } from '../../utils';
import { useObserver } from '../../utils/ObserverHooks';
export default function ThumbsUpButton(props) {
    var _a, _b;
    const button = useObserver(props.data);
    const { icon, disabled, onItemSelected, text } = button;
    const isLikesEveryWhereEnabled = ((_a = props.data.observer) === null || _a === void 0 ? void 0 : _a.storageGroup) === 'TRACK_RATINGS';
    const trackAsin = (_b = props.data.observer) === null || _b === void 0 ? void 0 : _b.storageKey;
    const trackRating = useSelector((state) => {
        var _a;
        if (isLikesEveryWhereEnabled === true) {
            const { TRACK_RATINGS } = state.Storage;
            return trackAsin && TRACK_RATINGS && TRACK_RATINGS[trackAsin]
                ? TRACK_RATINGS[trackAsin]
                : ((_a = props.data.observer) === null || _a === void 0 ? void 0 : _a.defaultState) || 'NEUTRAL';
        }
        const { RATINGS } = state.Storage;
        return RATINGS === null || RATINGS === void 0 ? void 0 : RATINGS.TRACK_RATING;
    });
    const onSelected = bindHandler(props.handleSelected, null, onItemSelected);
    const onActivate = (event) => {
        var _a;
        event.stopPropagation();
        (_a = event.detail) === null || _a === void 0 ? void 0 : _a.stopPropagation();
        onSelected();
    };
    const handleMouseEvent = (event) => {
        event.stopPropagation();
    };
    return (React.createElement("music-button", { slot: props.slot, ariaLabelText: text, onmusicActivate: onActivate, variant: trackRating === 'THUMBS_UP' ? 'accent' : 'primary', "icon-name": icon, "icon-only": true, disabled: disabled, size: props.size || 'small', onMouseUp: handleMouseEvent, onMouseDown: handleMouseEvent }));
}
